export default function QualityAssurance() {
  const qualityPoints = [
    {
      icon: 'ri-plant-line',
      title: 'Direct Sourcing',
      description: 'Products sourced directly from trusted farmers and suppliers ensuring authenticity and quality.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Hygienic Processing',
      description: 'Proper cleaning, grading, and hygienic processing following international standards.',
    },
    {
      icon: 'ri-box-3-line',
      title: 'Secure Packaging',
      description: 'Secure and reliable packaging designed for safe international export and delivery.',
    },
    {
      icon: 'ri-truck-line',
      title: 'Reliable Supply Chain',
      description: 'Consistent quality control and dependable supply chain management for global buyers.',
    },
  ];

  return (
    <section id="quality" className="py-12 lg:py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Title */}
        <div className="text-center mb-10">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Quality Assurance
          </h2>
          <p className="text-lg text-gray-600">
            Maintaining strict quality standards for international export
          </p>
        </div>

        {/* Quality Points Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {qualityPoints.map((point, index) => (
            <div key={index} className="text-center relative">
              {/* Vertical Separator */}
              {index < qualityPoints.length - 1 && (
                <div className="hidden lg:block absolute top-1/4 right-0 w-px h-1/2 bg-gray-200"></div>
              )}

              {/* Icon */}
              <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center">
                <i className={`${point.icon} text-4xl text-white`}></i>
              </div>

              {/* Title */}
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {point.title}
              </h3>

              {/* Description */}
              <p className="text-gray-600 leading-relaxed">
                {point.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}